module.exports = __webpack_public_path__ + "8808f7ef7d5731abf1d207a23d2f5266.svg";